// extracted by mini-css-extract-plugin
export var hidden = "_60-1";
export var leftPanel = "_60-2";
export var readonlyInspector = "_60-3";
export var rightPanel = "_60-0";